import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import PageHero from '@/components/feature/PageHero';
import AlabasterContact from '@/pages/alabaster/components/AlabasterContact';

const services = [
  {
    icon: 'ri-route-line',
    title: 'Itinerary Design',
    desc: 'Independent travel advisory for individuals, families, and groups, built around an itinerary designed for the trip you want.',
  },
  {
    icon: 'ri-flight-takeoff-line',
    title: 'Booking & Reservations',
    desc: 'Booking of accommodations, transportation, tours, and reservations.',
  },
  {
    icon: 'ri-group-line',
    title: 'Group Travel',
    desc: 'Group travel, including retreats and multi-family trips with rooming lists and payment tracking.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Concierge Support',
    desc: 'Concierge support during the trip, so you have help while you travel.',
  },
];

export default function Alabaster() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <PageHero
        eyebrow="A Division of Penland LLC"
        title="Alabaster"
        titleAccent="Travel"
        subtitle="Independent travel advisory for individuals, families, and groups."
        image="https://readdy.ai/api/search-image?query=Stylized%20dreamy%20coastal%20horizon%20with%20soft%20gradient%20sky%20and%20calm%20sea%20in%20warm%20sand%20and%20teal%20tones%2C%20minimal%20elegant%20travel%20backdrop%2C%20cinematic%20soft%20light%20and%20subtle%20mist&width=1600&height=900&seq=alabaster-hero-01&orientation=landscape"
        imageAlt="Soft coastal horizon representing Alabaster Travel"
        cta={{ label: 'Start Planning', href: 'https://alabastertravel.com/plan-your-trip', external: true }}
      />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="mb-12 md:mb-16">
              <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
                What We Offer
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl leading-tight">
                Travel planning,
                <span className="italic text-accent-600"> start to finish</span>
              </h2>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
              {services.map((svc, i) => (
                <div
                  key={i}
                  className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/60 hover:border-accent-300/40 hover:-translate-y-1 transition-all flex flex-col"
                >
                  <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                    <i className={`${svc.icon} text-accent-600 text-2xl`} />
                  </div>
                  <h3 className="font-heading text-lg md:text-xl text-primary-950 font-semibold mb-3">
                    {svc.title}
                  </h3>
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                    {svc.desc}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-10 md:mt-12 bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-8 flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center shrink-0">
                <i className="ri-information-line text-secondary-700 text-2xl" />
              </div>
              <p className="text-foreground-600 text-base leading-relaxed">
                Alabaster Travel is a trade name of Penland LLC, and supplier terms and
                cancellation policies come with each quote.
              </p>
            </div>
          </div>
        </div>
      </section>

      <AlabasterContact />
      <SiteFooter />
    </main>
  );
}